import React from "react";
import firebase from "../firebase.js";

class Mike extends React.Component {
  state = {
    items: []
  };


  componentDidMount() {
    const _self = this;
    this.firebaseCallback = firebase
      .database()
      .ref("/list/searchTypes")
      .on("value", function(snap) {
        var items = [];
        snap.forEach(function(itemSnap) {
          items.push(itemSnap.val());
        });

        _self.setState({ items: items });
      });
  }

  componentWillUnmount() {
    firebase
      .database()
      .ref("/items")
      .off("value", this.firebaseCallback);
  }

  render() {
    const _self = this;

    const namesList = this.state.items.sort((a,b) => a[_self.props.field] - b[_self.props.field]).map((name,index) => {
      return <div key={index}>{name[_self.props.field]}</div>;
    });

    return namesList;
  }
}

export default Mike;



// WEBPACK FOOTER //
// ./src/components/Mike.js